var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71598684","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
// module id = null
// module chunks = 